
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const AssetsPage = lazy(() => import('../pages/assets/page'));
const MaintenancePlansPage = lazy(() => import('../pages/maintenance-plans/page'));
const LocationsPage = lazy(() => import('../pages/locations/page'));
const InventoryPage = lazy(() => import('../pages/inventory/page'));
const ProceduresPage = lazy(() => import('../pages/procedures/page'));
const ReportsPage = lazy(() => import('../pages/reports/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/assets',
    element: <AssetsPage />
  },
  {
    path: '/maintenance-plans',
    element: <MaintenancePlansPage />
  },
  {
    path: '/locations',
    element: <LocationsPage />
  },
  {
    path: '/inventory',
    element: <InventoryPage />
  },
  {
    path: '/procedures',
    element: <ProceduresPage />
  },
  {
    path: '/reports',
    element: <ReportsPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
